import React from "react";
import CampaignCards from "../components/CampaignCards";

const Campaigns: React.FC = () => {
  return (
    <>
      <section className="relative bg-gray-900 py-16 md:py-24">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary opacity-80"></div>
        </div>
        <div className="relative container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Campaigns
          </h1>
          <p className="text-white/90 text-lg max-w-3xl mx-auto">
            Discover the causes we champion and support our mission to make a
            difference.
          </p>
        </div>
      </section>
      <CampaignCards />
    </>
  );
};

export default Campaigns;
